/* Carousel indicator for product cards.

   The design puts a 2px bar across the bottom of the card image showing how
   far through the image carousel you are. There are two shapes of it:

   - BJ-DS cards (`.bj-card`, Figma 640:3296 / 640:3428) get a *segmented*
     indicator: the track is divided into one equal segment per slide and the
     current slide's segment is filled black.

   - The flush recommendations grid predates that and keeps the original
     single moving fill, styled by component-recommendations-flush.css. Its
     cards are explicitly not `bj_card`, so the two never mix.

   Two constraints shape this:

   1. product-card-slider.js already builds the Swiper instance, so this reads
      from it rather than creating a second slider — two Swipers on one element
      fight over the same inline transforms.

   2. <product-recommendations> lazy-loads on intersection and replaces its own
      innerHTML (global.js:2385), then Swiper initialises on the new markup.
      A one-shot pass at DOMContentLoaded would therefore find nothing, so we
      observe the DOM and attach whenever a slider appears. */
(function () {
  /* .bj-card covers every DS card; the recommendations selector stays for
     the flush grid, which predates the shared card and has its own CSS. */
  var CARD_SELECTOR =
    '.bj-card .product-card-js, .product-recommendations--flush .product-card-js';
  var READY = 'bjProgressReady';

  /* Swiper reports realIndex in slide terms even in loop mode, where
     slides.length counts the duplicated slides; fall back to activeIndex on
     older instances that do not expose it. */
  function currentIndex(swiper, total) {
    var i = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
    if (typeof i !== 'number' || i < 0) i = 0;
    if (i > total - 1) i = total - 1;
    return i;
  }

  /* BJ-DS: one segment per slide, the active one filled. */
  function syncSegments(swiper, bar) {
    var total = swiper.slides ? swiper.slides.length : 0;
    if (total <= 1) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = '';

    if (bar.children.length !== total) {
      bar.textContent = '';
      for (var n = 0; n < total; n++) {
        var seg = document.createElement('div');
        seg.className = 'card-progress__segment';
        bar.appendChild(seg);
      }
    }

    var active = currentIndex(swiper, total);
    for (var i = 0; i < bar.children.length; i++) {
      bar.children[i].classList.toggle('is-active', i === active);
    }
  }

  /* Flush recommendations grid: the original single moving fill. */
  function syncFill(swiper, bar) {
    var fill = bar.firstChild;
    var total = swiper.slides ? swiper.slides.length : 0;
    if (total <= 1) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = '';
    fill.style.width = 100 / total + '%';
    fill.style.transform = 'translateX(' + swiper.activeIndex * 100 + '%)';
  }

  function attach(slider) {
    if (slider.dataset[READY] === 'true') return true;

    var swiper = slider.swiper;
    if (!swiper) return false; // Swiper has not initialised on this one yet.

    slider.dataset[READY] = 'true';

    var segmented = !!(slider.closest && slider.closest('.bj-card'));

    var bar = document.createElement('div');
    bar.className = 'card-progress';
    bar.setAttribute('aria-hidden', 'true');
    if (!segmented) {
      var fill = document.createElement('div');
      fill.className = 'card-progress__fill';
      bar.appendChild(fill);
    }
    slider.appendChild(bar);

    var sync = segmented ? syncSegments : syncFill;

    sync(swiper, bar);
    swiper.on('slideChange', function () {
      sync(swiper, bar);
    });
    swiper.on('update', function () {
      sync(swiper, bar);
    });
    return true;
  }

  /* Returns true when every slider currently in the DOM has a bar. */
  function sweep() {
    var sliders = document.querySelectorAll(CARD_SELECTOR);
    var done = true;
    for (var i = 0; i < sliders.length; i++) {
      if (!attach(sliders[i])) done = false;
    }
    return done;
  }

  var pending = null;

  /* Swiper may initialise a tick or two after the markup lands, so poll
     briefly after each DOM change rather than giving up on the first miss. */
  function sweepSoon() {
    if (pending) return;
    var tries = 0;
    pending = window.setInterval(function () {
      tries += 1;
      if (sweep() || tries > 20) {
        window.clearInterval(pending);
        pending = null;
      }
    }, 150);
  }

  function observe() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          sweepSoon();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    sweepSoon();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', sweepSoon);
})();
